import { createFileRoute } from "@tanstack/react-router";
import { MainSidebar } from "../../../components/sidebars/MainSidebar";
import { ServiceSettingsPage } from "../../../pages/admin/ServiceSettingsPage";

export const Route = createFileRoute("/admin/service-settings/")({
  component: AdminServiceSettings,
});

function AdminServiceSettings() {
  return (
    <div className="flex h-screen">
      <MainSidebar />
      <div className="flex-1 overflow-auto">
        <div className="max-w-7xl mx-auto p-6">
          <h1 className="h3 mb-6">Admin Settings</h1>
          <ServiceSettingsPage />
        </div>
      </div>
    </div>
  );
}
